import Link from 'next/link';

import { Book, UserProfile } from 'types';
import { lastActiveTime } from 'sdk';

import Links from '~/lib/helpers/link-helper';

import UserProfileImage from '../user-profile-image';
import UserReviewStars from '../user-review-stars';
import FollowButton from '../follow-button';
import MessageButton from './message-button';

import styles from '~/styles/components/product/seller-info.module.scss';
import Pill from '../pill';

interface ProductPageSellerInfoProps {
  seller: UserProfile;
  book: Book;
  style: 'small' | 'large';
}

export default function ProductPageSellerInfo({ style = 'large', ...props }: ProductPageSellerInfoProps) {
  return (
    <section>
      <h2 className={styles.title}>Meet the seller</h2>
      <div className={styles['seller-info-container']}>
        <div className={styles['image-active-container']}>
          <div className={styles['seller-photo']}>
            <UserProfileImage user={props.seller} />
          </div>
          {lastActiveTime(props.seller) && (
            <div className={styles['pill']}>
              <Pill text={lastActiveTime(props.seller)} tiny />
            </div>
          )}
        </div>
        <div className={styles['seller-info']}>
          <>
            {props.seller && (
              <Link href={Links.bookstore(props.seller).show} passHref>
                {props.seller.name}
              </Link>
            )}
            {props.seller?.seller_review?.num_ratings && (
              <div className={styles['seller-info-rating']}>
                <UserReviewStars user={props.seller} withCountText />
              </div>
            )}
          </>
        </div>
        <div className={styles['seller-action-button-container']}>
          <MessageButton book={props.book} user={props.seller} style={style} />
          <FollowButton
            seller={props.seller}
            buttonProps={{
              style: 'outline',
              size: 'small',
            }}
          />
        </div>
      </div>
    </section>
  );
}